/*
 * Copyright (c) Worldline 2022.
 */

import {Component, OnInit} from '@angular/core';
import {CookieAgreementStatus} from "../../constant/cookie-agreement-status";
import {SharedService} from "../../services/shared.service";
import {RootScopeService} from "../../services/rootscope.service";
import {filter, map} from "rxjs";
import {ActivationEnd, Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {CookieKeys} from "../../constant/cookie-keys";
import {Routes} from "../../constant/routes";
import {SessionService} from "../../services/session.service";

@Component({
    selector: 'app-wl-cookie-agreement',
    templateUrl: './wl-cookie-agreement.component.html'
})
export class WlCookieAgreementComponent implements OnInit {

    constructor(private rootScope: RootScopeService,
                private sharedService: SharedService,
                private router: Router,
                private cookieService: CookieService,
                private sessionService: SessionService) {
    }

    private last: any;
    private lastSessionId: any;

    ngOnInit(): void {
        const that = this;

        /**
         * When the location changes, agree to the cookie
         */
        this.router.events.pipe(
            filter(e => e instanceof ActivationEnd),
            map(e => (e as ActivationEnd).snapshot)
        ).subscribe(route => {
            if (that.askCookieAgreement()) {

                var validRoutes = [Routes.evidences, Routes.agreements, Routes.pendingSignature, Routes.signatures, Routes.resume, Routes.confirmCancellation, Routes.legalNotices, Routes.help];
                if (this.isValidRoute(validRoutes, this.router.url)) {
                    if (typeof this.last === "undefined" || typeof this.lastSessionId === "undefined" || this.lastSessionId !== this.sessionService.id) {

                        this.last = this.router.url;
                        this.lastSessionId = this.sessionService.id;
                        console.debug('First full page, agreement request is shown for session ' + this.sessionService.id);


                    } else {

                        this.last = this.router.url;
                        this.lastSessionId = this.sessionService.id;
                        console.debug('This is a page change, agreement can be accepted');
                        this.acceptCookieAgreement(false);

                    }
                }

            }
        })

    }

    askCookieAgreement(): any {
        if (!this.rootScope.get().properties) {
            return;
        }
        /**
         Did we activate cookie agreement at all ?
         */
        if (typeof this.rootScope.get().properties.cookieAgreement === "undefined" || this.rootScope.get().properties.cookieAgreement.active === false) {
            return false
        } else {
            /**
             * Return true if the Cookie Agreement is not set or set to a different value than the expected ones.
             */
            return (typeof this.cookieAgreementValue() === 'undefined' || this.cookieAgreementValue() !== CookieAgreementStatus.AGREED && this.cookieAgreementValue() !== CookieAgreementStatus.REFUSED);

        }
    }

    cookieAgreementValue() {
        return this.cookieService.get(CookieKeys.COOKIE_AGREEMENT)
    };

    hasLearnMore() {
        return !!this.rootScope.get().properties?.cookieAgreement?.noticeLink;
    };

    getLearnMoreLink() {
        return this.rootScope.get().properties?.cookieAgreement?.noticeLink;
    };

    // The user refuses that we add cookies
    refuseCookieAgreement() {
        console.debug('User refuses cookies');
        this.cookieService.set(CookieKeys.COOKIE_AGREEMENT, CookieAgreementStatus.REFUSED);
    };

    // The user wants to close the cookie agreement panel without refuse it
    closeCookieAgreementPanel() {
        console.debug('User closes panel, he accepts');
        this.acceptCookieAgreement(true);
    };

    acceptCookieAgreement(force) {
        // Can we change the cookieAgreement ? (already refused for example)
        if (this.askCookieAgreement() || force) {
            console.debug('User accepts cookies');
            this.cookieService.set(CookieKeys.COOKIE_AGREEMENT, CookieAgreementStatus.AGREED);
        }

    };

    private isValidRoute(validRoutes, route): boolean {
        let isValid = false;
        validRoutes.forEach(validRoute => {
            let routeType = validRoute.split('/')[1]
            if (route.includes('/' + routeType + '/')) {
                isValid = true;
                return;
            }
        })
        return isValid
    }

}
